/**
 * An id for a row this device has written but the server has not seen.
 *
 * Hermes has no `crypto` global, and this app installs no crypto module, so
 * `crypto.randomUUID()` throws "Property 'crypto' doesn't exist" and takes the
 * whole save with it. `Math.random` is enough here and the strength is not a
 * shortcut: these two ids live on one device, for the seconds between a save
 * and the server's answer, and `markSynced` throws them away for the real ids.
 * Nothing outside this phone ever sees one.
 *
 * The shape is a v4 UUID so a pending row and a stored row look alike to
 * everything that reads them.
 *
 * Warning: never use this for anything a stranger could guess at. A session
 * token, an invite code, or any id that gates access needs `expo-crypto`.
 */
const HEX = '0123456789abcdef';

/** One random hex digit. */
const digit = (): string => HEX[Math.floor(Math.random() * 16)] ?? '0';

export const newLocalId = (): string => {
  let out = '';
  for (let at = 0; at < 36; at += 1) {
    if (at === 8 || at === 13 || at === 18 || at === 23) {
      out += '-';
    } else if (at === 14) {
      out += '4'; // The version nibble.
    } else if (at === 19) {
      out += HEX[8 + Math.floor(Math.random() * 4)] ?? '8'; // The variant nibble.
    } else {
      out += digit();
    }
  }
  return out;
};
